import * as THREE from 'three'
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { VALIDATION_ERRORS, FILE_PATHS } from './constants.js'

export class ModelLoader {
  constructor() {
    this.stlLoader = new STLLoader()
    this.gltfLoader = new GLTFLoader()
  }

  async loadAll(config) {
    const [caseGeometry, boardGeometry, switchScene, keycapGeometry] = await Promise.all([
      this.loadSTL(config.casePath),
      this.loadSTL(config.boardPath),
      this.loadGLTF(FILE_PATHS.SWITCH_MODEL),
      this.loadSTL(FILE_PATHS.KEYCAP_MODEL)
    ])

    return {
      caseGeometry,
      boardGeometry,
      switchScene,
      keycapGeometry
    }
  }

  async loadSTL(path) {
    return new Promise((resolve, reject) => {
      this.stlLoader.load(
        path,
        (geometry) => {
          if (!geometry || !geometry.attributes || !geometry.attributes.position) {
            reject(new Error(VALIDATION_ERRORS.MODEL_LOAD_ERROR(path, 'Invalid STL geometry')))
            return
          }
          resolve(geometry)
        },
        undefined,
        (error) => reject(new Error(VALIDATION_ERRORS.MODEL_LOAD_ERROR(path, error.message)))
      )
    })
  }

  async loadGLTF(path) {
    return new Promise((resolve, reject) => {
      this.gltfLoader.load(
        path,
        (gltf) => {
          if (!gltf.scene) {
            reject(new Error(VALIDATION_ERRORS.MODEL_LOAD_ERROR(path, 'Invalid GLTF scene')))
            return
          }
          resolve(gltf.scene)
        },
        undefined,
        (error) => reject(new Error(VALIDATION_ERRORS.MODEL_LOAD_ERROR(path, error.message)))
      )
    })
  }
}